module.exports = __webpack_public_path__ + "static/img/huajiaoPic.4f43eb3a.png";